import { get } from "lodash"
import notification from "services/notification"
import { clearApiCache } from "./index"

function errorHandler(err: any) {
  const status = get(err, "response.status")

  // Only bounce to sign-in for an authenticated session that lost its token.
  // Guests on the public shop must stay where they are.
  if (status === 401 && localStorage.getItem("token")) {
    localStorage.removeItem("token")
    localStorage.removeItem("profile")
    sessionStorage.removeItem("user")
    clearApiCache()
    window.location.href = "/signin"
    return null
  }

  if (status >= 400 && status < 500) {
    // 422 = field validation; forms surface these inline, so skip the toast
    // to avoid duplicate / empty notifications.
    if (status !== 422) {
      const message = get(err, "response.data.message")
      if (message) notification.error(message)
    }
  }
  if (status >= 500) {
    notification.error("Serverda xatolik")
  }

  return null
}

export default errorHandler
